module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      James D. G. Dunn, Rowan Williams\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v(" "), _c('B', [_vm._v("James D. G. Dunn")]), _vm._v(" (1939–2020) was a renowned New Testament scholar and the longtime Lightfoot Professor of Divinity at Durham University. His numerous books include "), _c('I', [_vm._v("The Theology of Paul the Apostle")]), _vm._v(", "), _c('I', [_vm._v("Jesus according to the New Testament")]), _vm._v(", and the magisterial "), _c('I', [_vm._v("Christianity in the Making")]), _vm._v(" trilogy.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1Befm3V/tc-custom/9781467452540.jpg?1730408925845",
      "alt": "This image is the cover for the book Jesus according to the New Testament"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Jesus according to the New Testament\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("New Testament scholar James D. G. Dunn has published his research on Christian origins in numerous commentaries, books, and essays. In this small, straightforward book designed especially for a lay audience, Dunn focuses his fifty-plus years of scholarship on elucidating the New Testament witness to Jesus, from Matthew to Revelation. Dunn’s "), _c('i', [_vm._v("Jesus according to the New Testament ")]), _vm._v("constantly points back to the wonder of those first witnesses and greatly enriches our understanding of Jesus.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    William B. Eerdmans Publishing Company\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0